import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { DropdownItem } from '@innogy/common-ui/forms';
import { TrackToolStep } from '@analytics/models';
import { ScDropDownFormInput } from '@innogy/sitecore-forms/models';
import { FormState } from 'ngrx-forms';
import { DropdownComponent } from '@innogy/common-ui/forms';
import { TrackValueChangeDirective } from '@analytics/events';

@Component({
  selector: 'wl-sc-dropdown[control][fields][trackStep]',
  templateUrl: './sc-dropdown.component.html',
  standalone: true,
  imports: [DropdownComponent, TrackValueChangeDirective],
})
export class ScDropdownComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() control!: FormState<string | null | undefined>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fields!: ScDropDownFormInput;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabels = false;

  dropdownItems: DropdownItem[] = [];

  ngOnInit() {
    this.dropdownItems = this.fields.Items.map((item) => ({
      label: item.fields.Label.value ?? '',
      value: item.fields.Value.value ?? '',
      icon: item.fields.Icon?.fields?.value?.value,
    }));
  }
}
